export const REMOVE_CUSTOMERS_LOCATION_REQUEST = 'REMOVE_CUSTOMERS_LOCATION_REQUEST';
export const REMOVE_CUSTOMERS_LOCATION_SUCCESS = 'REMOVE_CUSTOMERS_LOCATION_SUCCESS';
export const REMOVE_CUSTOMERS_LOCATION_FAILURE = 'REMOVE_CUSTOMERS_LOCATION_FAILURE';
